import { render, staticRenderFns } from "./RegularManagement.vue?vue&type=template&id=52fcdbb0&scoped=true&"
import script from "./RegularManagement.vue?vue&type=script&lang=js&"
export * from "./RegularManagement.vue?vue&type=script&lang=js&"
import style0 from "./RegularManagement.vue?vue&type=style&index=0&id=52fcdbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fcdbb0",
  null
  
)

export default component.exports